/**
 * PickerFooter — the workshop picker's confirm row. Cancel returns to whatever
 * opened the picker; the primary action commits the highlighted workshop, and
 * stays disabled until there is one.
 */
export interface PickerFooterProps {
  disabled: boolean;
  onBack: () => void;
  onConfirm: () => void;
}

export function PickerFooter({ disabled, onBack, onConfirm }: PickerFooterProps) {
  return (
    <div className="flex items-center justify-end gap-3 border-t border-stone-200 px-5 py-4 dark:border-stone-700">
      <button
        type="button"
        onClick={onBack}
        className="px-4 py-2 text-sm text-stone-600 hover:text-stone-800 dark:text-stone-400 dark:hover:text-stone-200"
      >
        Cancel
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={onConfirm}
        className="flex items-center gap-1.5 rounded-lg bg-moss-600 px-4 py-2 text-sm text-white transition hover:bg-moss-700 hover:text-white disabled:opacity-50"
      >
        Use this workshop
      </button>
    </div>
  );
}
